import identity from 'lodash/identity'
import pickBy from 'lodash/pickBy'
import callApi, { MAP_ENDPOINTS } from 'utils/api/callApi'
import { TGetGeocodingSearchResponse } from '../types/api'
import { IGeocodingSearchParams } from './types'

interface IGetMapGeocodeResponse {
  features: TGetGeocodingSearchResponse
}

/**
 * Returns array of locations that match
 * @method GET
 */
export const getMapGeocode = async (
  latLngTuple: [number, number],
  params?: Pick<IGeocodingSearchParams, 'searchString'>
): Promise<IGetMapGeocodeResponse> => {
  const [latitude, longitude] = latLngTuple || []

  let response: IGetMapGeocodeResponse = { features: [] }

  try {
    const features: TGetGeocodingSearchResponse = await callApi({
      endpoint: `${MAP_ENDPOINTS.places}`,
      method: 'GET',
      /**
       * @note Remove falsey values from object
       */
      params: pickBy(
        {
          ...params,
          latitude,
          longitude,
        },
        identity
      ),
    })

    response = {
      features,
    }
  } catch (e) {
    // no op
  }

  return response
}
